var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOverviewMatrix(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 13,
    viewBox: "0 0 14 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.27273 1.27273V8.90909H12.7273V1.27273H1.27273ZM1.27273 0H12.7273C13.4273 0 14 0.566364 14 1.27273V8.90909C14 9.24636 13.8664 9.57091 13.6245 9.80636C13.3891 10.0482 13.0645 10.1818 12.7273 10.1818H8.27273V11.4545H9.54545V12.7273H4.45455V11.4545H5.72727V10.1818H1.27273C0.935455 10.1818 0.610909 10.0482 0.375455 9.80636C0.133636 9.57091 0 9.24636 0 8.90909V1.27273C0 0.566364 0.566364 0 1.27273 0Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.2 4.7C5.86375 4.7 6.4 5.23625 6.4 5.9C6.4 6.56375 5.86375 7.1 5.2 7.1C4.53625 7.1 4 6.56375 4 5.9C4 5.23625 4.53625 4.7 5.2 4.7ZM8.05 6.5C8.24891 6.5 8.43968 6.57902 8.58033 6.71967C8.72098 6.86032 8.8 7.05109 8.8 7.25C8.8 7.44891 8.72098 7.63968 8.58033 7.78033C8.43968 7.92098 8.24891 8 8.05 8C7.85109 8 7.66032 7.92098 7.51967 7.78033C7.37902 7.63968 7.3 7.44891 7.3 7.25C7.3 7.05109 7.37902 6.86032 7.51967 6.71967C7.66032 6.57902 7.85109 6.5 8.05 6.5ZM8.2 2C8.43638 2 8.67044 2.04656 8.88883 2.13702C9.10722 2.22748 9.30565 2.36006 9.47279 2.52721C9.63994 2.69435 9.77252 2.89278 9.86298 3.11117C9.95344 3.32956 10 3.56362 10 3.8C10 4.79375 9.19375 5.6 8.2 5.6C7.72261 5.6 7.26477 5.41036 6.92721 5.07279C6.58964 4.73523 6.4 4.27739 6.4 3.8C6.4 2.80625 7.20625 2 8.2 2Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOverviewMatrix);
export default __webpack_public_path__ + "static/media/overviewMatrix.6d036e20.svg";
export { ForwardRef as ReactComponent };